<template>
  <div>
    <template>
      <VueFileAgent
        ref="vueFileAgent"
        v-model="fileRecords"
        :theme="'list'"
        :multiple="false"
        :deletable="true"
        :editable="false"
        :linkable="true"
        :accept="'application/pdf'"
        :help-text="'Choisissez les fichier pdf'"
        :error-text="{
          type: 'Type de fichier invalide. Seuls les fichiers PDF sont autorisés !',
        }"
        @select="filesSelected($event)"
        @beforedelete="onBeforeDelete($event)"
        @delete="fileDeleted($event)"
      ></VueFileAgent>
    </template>
  </div>
</template>

<script>
import links from "@/links/links";
import MediaMW from "@/middlewares/Media";
export default {
  props: {
    buildingOwnerId: {
      type: String,
      default: "",
    },
    lreAgreementMedia: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      links: links,
      fileRecords: [],
    };
  },
  created() {
    // Create fileRecords for upload zone with existing media
    if (this.lreAgreementMedia) {
      this.createPdfFileRecord(this.lreAgreementMedia);
    }
    this.updateFileRecords();
  },
  methods: {
    async filesSelected(filesSelected) {
      if (filesSelected.length > 0) {
        let validTypeFiles = filesSelected.filter(file => file.error === false);
        if (validTypeFiles.length > 0) {
          let filesToBeUploaded = [];
          validTypeFiles.forEach(file => {
            filesToBeUploaded.push(file.file);
          });
          await MediaMW.MEDIA_CHECK_PDF_FORMAT(
            filesToBeUploaded,
            "buildingOwner",
            this.buildingOwnerId,
            "lreAgreement"
          ).then(async res => {
            if (res.response.data.invalidFiles.length > 0) {
              let invalidFilesErrorMessage = "";
              res.response.data.invalidFiles.forEach(file => {
                this.fileRecords = this.fileRecords.filter(f => f.file.name !== file.name + ".pdf");
                invalidFilesErrorMessage +=
                  "<small><b>" +
                  file.name +
                  ".pdf</b> ce fichier a un format différent du A4 !</small> </br>";
              });
              this.$swal({
                icon: "error",
                title: "Erreur de téléchargement PDF !",
                html: invalidFilesErrorMessage,
              });
            }
            if (res.response.data.validFiles.length > 0) {
              res.response.data.validFiles.forEach(file => {
                // Filter the files added automatically and add them manually in createPdfFileRecord
                this.fileRecords = this.fileRecords.filter(f => f.media != undefined);
                this.createPdfFileRecord(file, true);
              });
              this.updateFileRecords();
            }
          });
        }
      }
    },
    onBeforeDelete(fileRecord) {
      this.$swal(this.alertQuestion())
        .then(res => {
          if (res.value) {
            this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
          }
        })
        .catch(err => {
          console.log("err", err);
          this.$swal(this.alertError());
        });
    },
    fileDeleted(fileRecord) {
      this.deleteFileRecord(fileRecord);
    },
    createPdfFileRecord(media) {
      let mediaName = media.label ? media.label : media.name || media.filename;
      let defaultRecord = {};
      var file = new File([0], mediaName + ".pdf", {
        type: "application/pdf",
      });
      defaultRecord["media"] = media;
      defaultRecord["file"] = file;
      if (media.file_path) {
        defaultRecord["url"] = links.API_WEB_APP_MEDIA_LINK(media.file_path);
      }
      this.fileRecords.push(defaultRecord);
    },
    updateFileRecords() {
      this.$emit("updateFileRecords", this.fileRecords);
    },
    deleteFileRecord(fileRecord) {
      this.$emit("deleteFileRecord", fileRecord);
    },
  },
};
</script>
